var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M275.303 756.035c0 16.566-2.958 31.358-8.875 44.375-5.917 12.848-13.693 24.259-23.329 34.233-9.467 9.635-20.37 18.68-32.711 27.132-12.34 8.453-25.442 16.652-39.304 24.597v57.054h-45.39v-77.34a3151.36 3151.36 0 0 0 35.5-20.54c12.848-7.438 23.33-14.96 31.444-22.568 9.805-8.79 17.412-17.835 22.821-27.132 5.41-9.467 8.115-21.47 8.115-36.008 0-19.102-6.509-33.303-19.525-42.6-12.848-9.467-29.5-14.2-49.955-14.2-32.728 1.207-79.344 14.33-107.662 40.626h-2.536v-51.73c31.219-21.876 81.323-32.116 113.748-32.258 36.346 0 65 8.875 85.962 26.626 21.131 17.58 31.697 40.825 31.697 69.733zm-100.162 288.821h-51.73v-53.504h51.73z",
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "519.32067871px",
      lineHeight: "125%",
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#d71e1e",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(0 -652.362)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlank);
export default __webpack_public_path__ + "static/media/Blank.4b14f3910539d2df1ae6f7e3b2a73901.svg";
export { ForwardRef as ReactComponent };